import * as React from 'react';
import type AppError from '../../../lib/AppError';
import Toast from '../Toast/Toast';
import cn from '~modules/cn';
import Styles from './base-modal-error-toast.module.scss';

type Props = {
    errorString: string;
    error: AppError;
    className?: string;
};

const BaseModalErrorToast = (props: Props) => {
    const [isErrorDetailsVisible, setErrorDetailsVisible] = React.useState(false);
    return (
        <Toast
            type="error"
            label={props.errorString}
            className={cn(props.className, Styles.container)}
            icon={null}
            showCloseButton={false}
            buttonTitle={isErrorDetailsVisible ? 'Hide details' : 'See details'}
            onButtonClick={() => {
                setErrorDetailsVisible(!isErrorDetailsVisible);
            }}
            error={isErrorDetailsVisible ? props.error : undefined}
            animate={false}
        />
    );
};

export default BaseModalErrorToast;
